












































import _ from "lodash";
import Vue from "vue";

//vjsf
import "@koumoul/vjsf/lib/VJsf.css";
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import "@koumoul/vjsf/lib/deps/third-party.js";

// model
import { EditFolderDataCommand, EditFolderDataReqData } from "@/model/communication/foldersManagement/EditFolderDataCommand";
import { GetFolderRoleDataCommand } from "@/model/communication/foldersManagement/GetFolderRoleDataCommand";
import { FolderDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";
import { FolderRole } from "@/model/data/deviceTree/FolderRole";

export default Vue.extend({
    components: { VJsf },
    data() {
        return {
            loading: true,
            selectedConverter: null,
            selectedFolderRoleTitle: null,

            folderData: {},
            isFormValid: false,

            formOptions: {
                initialValidation: "defined",
                autofocus: false,
                locale: "en",
                objectContainerClass: "justify-center",
                sectionsTitlesClasses: ["text-h5", "text-h6", "text-h7"],
            },
            deviceDetailValid: false,
        };
    },
    props: {
        folder: { type: FolderDeviceTreeNode, required: true },
        availableFolderRoles: { type: Array as () => Array<FolderRole>, required: false },
    },
    computed: {
        isDebug: () => process.env.NODE_ENV == "development",
        availableConverterNames() {
            if (this.availableFolderRoles) return _.uniq(this.availableFolderRoles.map((f) => f.converterType));
            else return [];
        },
        currentRoleSchema() {
            if (!!this.selectedConverter && !!this.selectedFolderRoleTitle)
                return this.availableFolderRoles.find((fr) => fr.converterType == this.selectedConverter && fr.roleTitle == this.selectedFolderRoleTitle).roleSchema;
            else return null;
        },
    },
    watch: {
        selectedConverter() {
            console.log("selectedConverter changed");
            this.selectedFolderRoleTitle = null;
            this.GetFolderData();
        },
        selectedFolderRoleTitle() {
            this.clearForm();
        },
        availableFolderRoles: {
            handler() {
                if (this.availableConverterNames && this.availableConverterNames.length == 1) this.selectedConverter = this.availableConverterNames[0];
                this.loading = false;
            },
            deep: true,
        },
    },
    methods: {
        onClose() {
            console.log("onClose()");
            this.$emit("close");
        },
        async GetFolderData() {
            try {
                this.loading = true;
                const res = await new GetFolderRoleDataCommand(this.folder.id, this.selectedConverter).execute();
                if (res.roleTitle)
                    if (this.availableFolderRoles.some((fr) => fr.converterType == this.selectedConverter && fr.roleTitle === res.roleTitle)) {
                        this.selectedFolderRoleTitle = res.roleTitle;
                        this.folderData = JSON.parse(res.folderData);
                    } else
                        console.warn(
                            "In the database this folder is saved with role title:",
                            res.roleTitle,
                            "This role is now not among the available roles. Available folder roles for the converter",
                            this.selectedConverter,
                            "are:",
                            this.availableFolderRoles.filter((fr) => fr.converterType == this.selectedConverter).map((fr) => fr.roleTitle)
                        );
                else console.warn("No folder role title found");
            } catch (error) {
                console.error("GetFolderData exc:", error);
            } finally {
                this.loading = false;
            }
        },
        async EditFolderData() {
            try {
                this.loading = true;
                const reqData = new EditFolderDataReqData(this.folder.id, this.selectedConverter, this.selectedFolderRoleTitle, JSON.stringify(this.folderData));
                const res = await new EditFolderDataCommand(reqData).execute();
                console.log("res", res);
                this.loading = false;
                this.onClose();
            } catch (error) {
                console.error("GetFolderData exc:", error);
            } finally {
                this.loading = false;
            }
        },
        onCancel() {
            console.log("onCancel()");
        },
        clearForm() {
            if (this.$refs.form) {
                this.folderData = {};
                this.$refs.form.reset();
            }
        },
        fillFormWithMockData() {
            switch (this.selectedFolderRoleTitle) {
                case "Branch":
                case "Pippo branch role":
                    this.folderData = { name: "Mirandola", country: "Italy", countryCode: "IT", eodTime: "20:30", timeZone: "Europe/Rome" };
                    break;
                case "Customer":
                    this.folderData = {
                        name: "Famila",
                        id: "f4604fb2-645a-44bd-be75-b72ffd5963d5",
                        uuid: "6b9bcdd5-e3d6-4af6-9445-e00d72cba715",
                        extId: "1a0654e8-1a76-4f40-ad66-e63076112cb1",
                        cmsId: "017ad23e-1687-46c4-ad43-e32a0b144c06",
                    };
                    break;
                case "Branch CIT region":
                    this.folderData = { name: "Emilia Romagna" };
                    break;
                case "Customer group":
                    this.folderData = { name: "Famila Group" };
                    break;
                default:
                    break;
            }
        },
    },
});
